import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import * as api from '@owl-nest/api-client/latest'
import * as models from '@owl-nest/models'
import * as hooks from '@owl-nest/hooks'

import { pureBackofficeScreens, Screen } from '../constants'

export function useMakeLinkClickHandler({
  screen,
  project,
  href,
}: {
  screen: Screen
  project: api.Project
  href: string
}): { onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void; href: string } {
  const isPureBackoffice =
    pureBackofficeScreens.includes(screen) && (screen !== Screen.DASHBOARD || models.project.isMembership(project))
  const navigate = isPureBackoffice ? useNavigate() : undefined

  const clickHandler = React.useMemo(
    () =>
      isPureBackoffice && navigate
        ? hooks.makeLinkClickHandler({
            navigate: () => navigate(href),
          })
        : undefined,
    [isPureBackoffice, navigate],
  )

  return { onClick: (event: React.MouseEvent<HTMLAnchorElement>) => clickHandler?.(event), href }
}
